// extracted by mini-css-extract-plugin
export default {"threePsCodesContainer":"threePsCodes_threePsCodesContainer__JUiaw","tableCtn":"threePsCodes_tableCtn__gv4Uj","tablePaginationCtn":"threePsCodes_tablePaginationCtn__q+3p3"};